import React, { useCallback } from "react";
import { View, StyleSheet } from "react-native";
import { useCompanionThreads } from "../contexts/CompanionThreadsContext";
import WorkspaceSidebarContainer from "../containers/companion/WorkspaceSidebarContainer";
import CompanionErrorModal from "../components/companion/CompanionErrorModal/CompanionErrorModal";
import SkipLink from "../components/common/general/SkipLink";

function CompanionLayout({ children }: { children: React.ReactNode }) {
  const { error, hideError, showError } = useCompanionThreads();

  const handleRetry = useCallback(async () => {
    if (!error?.onRetry) {
      return;
    }

    const previousError = error;
    hideError();

    try {
      await previousError.onRetry();
    } catch (retryError) {
      const message = retryError instanceof Error ? retryError.message : previousError.message;
      showError({
        ...previousError,
        message: message || previousError.message,
      });
    }
  }, [error, hideError, showError]);

  return (
    <>
      <SkipLink />
      <View style={[styles.container, { flexDirection: "column" }]}>
        <View style={styles.content}>
          <WorkspaceSidebarContainer />
          <View style={styles.childrenWrapper} id="main-content" tabIndex={0} role="main" accessibilityRole="main">
            {children}
          </View>
        </View>
      </View>
      {error && (
        <CompanionErrorModal
          visible={!!error}
          title={error.title}
          message={error.message}
          onClose={() => {
            error.onClose?.();
            hideError();
          }}
          onRetry={error.onRetry ? handleRetry : undefined}
          retryButtonText={error.retryButtonText}
        />
      )}
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
    // @ts-expect-error - works on web
    maxHeight: "100vh",
    overflow: "hidden",
    position: "relative",
    zIndex: 1,
  },
  content: {
    flex: 1,
    flexDirection: "row",
    position: "relative",
    zIndex: 1,
  },
  childrenWrapper: {
    flex: 1,
    position: "relative",
    zIndex: 1,
  },
});

export default CompanionLayout;
